// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"b81e653a","334":"84e7f718","447":"d40b73ca","733":"c35e7e77","941":"bed0065e"}[chunkId] + ".chunk.js";
};